import { render } from "./RelatoryPage.vue?vue&type=template&id=9f36962c&scoped=true&ts=true"
import script from "./RelatoryPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./RelatoryPage.vue?vue&type=script&lang=ts&setup=true"

import "./RelatoryPage.vue?vue&type=style&index=0&id=9f36962c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f36962c"],['__file',"src/pages/relatory/RelatoryPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9f36962c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9f36962c', __exports__)) {
    api.reload('9f36962c', __exports__)
  }
  
  module.hot.accept("./RelatoryPage.vue?vue&type=template&id=9f36962c&scoped=true&ts=true", () => {
    api.rerender('9f36962c', render)
  })

}


export default __exports__